
import filters from "@/filters";
import { Component, Vue, Watch } from "vue-property-decorator";
import AppLayout from "@/layouts/AppLayout.vue";
import { Action, State, Mutation, Getter } from "vuex-class";
import CourseItem from "@/components/CourseItem.vue";
import { AxiosResponse } from "axios";
import _, { set } from "lodash";
import ContentFooter from "@/components/ContentFooter.vue";
import FeedbackWidget from "@/components/FeedbackWidget.vue";
import { get, param } from "jquery";

@Component({
  components: {
    CourseItem,
    AppLayout,
    ContentFooter,
    FeedbackWidget,
  },
  filters,
  metaInfo: {
    meta: [
      {
        name: "keywords",
        content:
          "Job fair, Career fair, Employment fair, Career expo, Job fair near me, Virtual job fair, Career fair opportunities, Job fair preparation, Job fair interviews, Bursa kerja, Pameran karir, Job fair Indonesia, Pameran pekerjaan, Bursa kerja online, Job fair virtual, Tips job fair, Persiapan job fair, Bursa kerja kampus, Peluang job fair, Pameran karir online",
      },
    ],
  },
})
export default class Home extends Vue {
  @Action("getBanner", { namespace: "general" })
  private getBanner: any;
  @Action("getCategory", { namespace: "general" })
  private getCategory: any;
  @Action("getTopCourse", { namespace: "general" })
  private getTopCourse: any;
  @Action("getTopRating", { namespace: "general" })
  private getTopRating: any;
  @Action("getBundleCourse", { namespace: "bundleCourse" })
  private getBundleCourse: any;
  @Action("getCourse", { namespace: "course" })
  private getCourse: any;
  @Action("getInstructors", { namespace: "instructor" })
  private getInstructors: any;

  @State('user', { namespace: 'auth' })
  private user: any;

  private banners = [];
  private categories = [];
  private bundleCourses = [];
  private bundleCourseTotal = 0;
  private bundleCourseCategory: any = null;
  private bundleCourseFilter = "latest";
  private courses = [];
  private courseTotal = 0;
  private instructors = [];
  private courseCategory: any = null;
  private courseFilter = "latest";
  private topCourses = [];
  private ratings = [];
  private courseCarousel = {
    0: {
      items: 1,
    },
    768: {
      items: 2,
    },
    1200: {
      items: 4,
    },
  };

  private featuredItems = [1, 2, 3]; // Current order: left, center, right

  @Watch("bundleCourseCategory")
  private onBundleCourseCategory() {
    this.getBundleCourseData();
  }

  @Watch("bundleCourseFilter")
  private onBundleCourseFilter() {
    this.getBundleCourseData();
  }

  @Watch("courseCategory")
  private onCourseCategory() {
    this.getCourseData();
  }

  @Watch("courseFilter")
  private onCourseFilter() {
    this.getCourseData();
  }

  private get topInstructors() {
    return this.instructors;
  }

  private nextFeature() {
    // Rotate featured items: [1,2,3] -> [2,3,1] -> [3,1,2] -> [1,2,3]
    this.featuredItems = [
      this.featuredItems[1],
      this.featuredItems[2],
      this.featuredItems[0]
    ];
  }

  private previousFeature() {
    // Rotate featured items in reverse: [1,2,3] -> [3,1,2] -> [2,3,1] -> [1,2,3]
    this.featuredItems = [
      this.featuredItems[2],
      this.featuredItems[0],
      this.featuredItems[1]
    ];
  }

  private getFeaturedImage(featureNumber: number): string {
    const images = {
      1: require('@/assets/logo/icon-01-medali-pemula-transparent.png'),
      2: require('@/assets/logo/icon-02-peta-kompas-transparent.png'),
      3: require('@/assets/logo/icon-03-dompet-hemat-transparent.png')
    };
    return images[featureNumber as keyof typeof images];
  }

  private getFeaturedTitle(featureNumber: number): string {
    return `home_feature_${featureNumber}`;
  }

  private getFeaturedContent(featureNumber: number): string {
    return `home_feature_${featureNumber}_content`;
  }

  private created() {
    this.getBanner({
      success: (response: AxiosResponse) => {
        this.banners = response.data.data;
      },
    });
    this.getCategory({
      success: (response: AxiosResponse) => {
        this.categories = response.data.data.data;
      },
    });
    this.getTopCourse({
      success: (response: AxiosResponse) => {
        this.topCourses = response.data.data.data;
      },
    });
    this.getTopRating({
      success: (response: AxiosResponse) => {
        this.ratings = response.data.data.data;
      },
    });

    this.getBundleCourseData();
    this.getCourseData();
    this.getInstructorData();
  }

  private getBundleCourseData(page: number = 1) {
    this.getBundleCourse({
      params: {
        page: page || 1,
        category: this.bundleCourseCategory?.id,
        filter: this.bundleCourseFilter,
      },
      success: (response: AxiosResponse) => {
        this.bundleCourses = [];
        this.bundleCourseTotal = 0;
        this.$nextTick(() => {
          this.bundleCourses = response.data.data.data;
          this.bundleCourseTotal = response.data.data.total;
        });
      },
    });
  }

  private getCourseData(page: number = 1) {
    this.getCourse({
      params: {
        page: page || 1,
        category: this.courseCategory?.id,
        filter: this.courseFilter,
      },
      success: (response: AxiosResponse) => {
        this.courses = [];
        this.courseTotal = 0;
        this.$nextTick(() => {
          this.courses = response.data.data.data;
          this.courseTotal = response.data.data.total;
        });
      },
    });
  }

  private getInstructorData() {
    this.getInstructors({
      success: (response: AxiosResponse) => {
        const instructors = response.data.data || [];
        this.instructors = instructors.sort((a: any, b: any) => {
          return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
        });
      },
    });
  }

  private mailTo(email: string) {
    window.open(email, "_blank");
  }

  private mounted() {
    // AppNavbar will handle tour initialization
  }
}
